import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";
import ParaFazer from "./ParaFazer";
import Fazendo from "./Fazendo";
import Feita from "./Feita";
import { TFiltrosTarefas, THandleOpenDetailDialog } from "../..";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

export default function KanbanDisplay({
    keyword,
    filtros,
    handleOpenModalDetail
}: KanbanDisplayProps) {

    const theme = useTheme();
    const location = useLocation();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const codigoParam = location.state?.codigo || null;

    const [codigoPreenchido, setCodigoPreenchido] = useState<string | null>(codigoParam)

    useEffect(() => {
        if (codigoPreenchido) {
            const timeoutId = setTimeout(() => {
                setCodigoPreenchido(null);
            }, 3200);

            return () => clearTimeout(timeoutId);
        }
    }, [codigoPreenchido])

    return (
        <>
            {
                isMobile ? (
                   
                    <Box
                        mt={2}
                        display="flex"
                        flexDirection="row"
                        overflow="auto"
                    >
                        <Box mr={2} minWidth={300}>
                            <ParaFazer {...{ keyword, codigoPreenchido, filtros }} onClickDetalheProcesso={(codigo) => handleOpenModalDetail(codigo)} />
                        </Box>

                        <Box mr={2} minWidth={300}>
                            <Fazendo {...{ keyword, codigoPreenchido, filtros }} onClickDetalheProcesso={(codigo) => handleOpenModalDetail(codigo)} />
                        </Box>

                        <Box mr={2} minWidth={300}>
                            <Feita {...{ keyword, codigoPreenchido, filtros }} onClickDetalheProcesso={(codigo) => handleOpenModalDetail(codigo)} />
                        </Box>
                    </Box>
                ) : (
                    <Grid container minHeight={300} spacing={2} mt={2}>
                        <Grid size={{xs: 12, md: 4}}>
                            <ParaFazer {...{ keyword, codigoPreenchido, filtros }} onClickDetalheProcesso={(codigo) => handleOpenModalDetail(codigo)} />
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                            <Fazendo {...{ keyword, codigoPreenchido, filtros }} onClickDetalheProcesso={(codigo) => handleOpenModalDetail(codigo)} />
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                            <Feita {...{ keyword, codigoPreenchido, filtros }} onClickDetalheProcesso={(codigo) => handleOpenModalDetail(codigo)} />
                        </Grid>
                    </Grid>
                )
            }
        </>
    )
}

interface KanbanDisplayProps {
    keyword: string
    filtros: TFiltrosTarefas | null
    handleOpenModalDetail: THandleOpenDetailDialog
}